import React from "react";

function NotFound(){

    return(
        <div className="row min-vh-100 py-6 text-center">
          <div className="col-">
            <div className="card">
              <div className="card-body p-4 p-sm-5">
                <div className="fw-black lh-1 text-300 fs-error">ERROR</div>
                <p className="lead mt-4 text-800 font-sans-serif fw-semi-bold w-md-75 w-xl-100 mx-auto">Error processing request or access to the resource denied.</p>
                <hr />
                <p>Make sure you have the right privilege to access the resource. <br />If you think this is a mistake, <a href="mailto:info@exmaple.com">contact ADMIN</a>.</p><a className="btn btn-primary btn-sm mt-3" href="#/"><span className="fas fa-home me-2"></span>Take me home</a>
              </div>
            </div>
          </div>
        </div>
    )
}

export default NotFound;
